<template>
  <!-- NOTIFICATIONS -->
  <!-- vs-trigger-click -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="CpuIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
      :badge="actives.length"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <template v-if="activities.length != 0">
          <h3 class="text-white">{{ actives.length }} {{ $t('activities') | capitalize}}</h3>
          <p class="opacity-75">{{ $t('actives') | capitalize }}</p>
        </template>
        <template v-else>
          <p class="opacity-75">
            {{ $t('none_activities_to_show') || capitalize }}
          </p>
        </template>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="(activity, index) in activities"
            :key="index"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="getIcon(activity.status)"
                :svgClasses="[
                  'stroke-current mr-1 h-6 w-6',
                  getColor(activity.status),
                ]"
              ></feather-icon>
              <div class="mx-2">
                <!-- <span
                  class="font-medium block notification-title"
                  :class="[`text-${ntf.color}`]"
                >
                </span> -->
                <small>
                  <strong> {{ activity.module }} - </strong>
                  {{ activity.name }}
                </small>
                
              </div>
            </div>
          </li>
        </ul>
      </component>
      <div
        class="checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
        @click="clear"
      >
        <span class="flex items-center justify-center">
          <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
          <span class="ml-2">{{ $t('clear') | capitalize }}</span>
        </span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar,
  },

  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      statusList: [
        {
          id: '1',
          text: 'Done',
          icon: 'CheckCircleIcon',
          color: 'text-success',
        },
        {
          id: '2',
          text: 'Process',
          icon: 'PlayCircleIcon',
          color: 'text-info',
        },
        {
          id: '3',
          text: 'Warning',
          icon: 'AlertCircleIcon',
          color: 'text-warning',
        },
        {
          id: '4',
          text: 'Error',
          icon: 'XCircleIcon',
          color: 'text-primary',
        },
      ],
    }
  },

  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },

    actives() {
      return this.$store.state.activity.activities.filter(
        (i) => i.status == '2'
      )
    },
    
    activities() {
      return this.$store.state.activity.activities
    },
  },

  methods: {
    getIcon(status) {
      return this.statusList.find((i) => i.id == status).icon
    },

    getColor(status) {
      return this.statusList.find((i) => i.id == status).color
    },

    clear() {
     this.$store.dispatch('activity/clear');
    },
  },
}
</script>

